/**
 * Legacy plan wire-value maps. DEPRECATED - use Plan from src/domain/plan.
 *
 * Split out of utils/Constants.js (roadmap Module 8) — Constants.js remains
 * a re-export shim until import sites migrate to "src/constants/plans".
 */
// Canonical 4-tier subscription wire values. The BE migrated legacy
// `personal_free` / `business_trial` / `business_trial_ended` /
// `court_document` server-side (subscription-tiers-rewrite Group 9.6 +
// 9.7); the FE only sees the four below now. `pre_onboarding` is treated
// as `free_tier` by all callers.
//
// Legacy aliases (INHOUSE_ASK, PERSONAL_FREE, etc.) were dropped — callers
// import FREE_TIER / SUBSCRIBER_BUSINESS / SUBSCRIBER_ENTERPRISE /
// INHOUSE_COUNSEL_TIER directly, or use the wire value literally.
/**
 * @deprecated Use `Plan` from src/domain/plan instead — e.g.
 * `Plan.from(subscriptionType).isFree()` rather than comparing against these
 * values. Removed once Modules 3-4 of docs/domain-refactor-roadmap.md migrate
 * the remaining consumers.
 */
export const PLANS = {
  PRE_ONBOARDING: "pre_onboarding",
  // Free tier — `free_tier` wire value.
  INHOUSE_ASK: "free_tier",
  // Pro tier — `subscriber_business` wire value.
  INHOUSE_PRO: "subscriber_business",
  SUBSCRIBER_BUSINESS: "subscriber_business",
  // Counsel tier — `subscriber_enterprise` wire value. The constant name
  // INHOUSE_COUNSEL is historical (predates the 4-tier rollout, where the
  // wire string `inhouse_counsel` was repurposed for the *Unlimited* tier).
  // Per Group 9.10 the wire value `inhouse_counsel` refers exclusively to
  // the Unlimited tier; this key is the FE label for the Counsel tier's
  // `subscriber_enterprise` wire value and is preserved for backward-compat
  // with existing call sites.
  INHOUSE_COUNSEL: "subscriber_enterprise",
  SUBSCRIBER_ENTERPRISE: "subscriber_enterprise",
  // Unlimited tier — `inhouse_counsel` wire value.
  INHOUSE_UNLIMITED: "inhouse_counsel",
};

/** @deprecated Use `Plan` from src/domain/plan (see PLANS deprecation note). */
export const PLANS_V3 = {
  PRE_ONBOARDING: "pre_onboarding",
  INHOUSE_FREE: "free_tier", // free
  INHOUSE_AI: "subscriber_business", // $49/mo
  INHOUSE_COUNSEL: "subscriber_enterprise", // $149/mo
  INHOUSE_COUNSEL_PLUS: "inhouse_counsel", // $499/mo
};

/** @deprecated Use `Plan.from(x).isFree()` from src/domain/plan. */
export const FREE_TIER = "free_tier";
export const subscriber_enterprise = "subscriber_enterprise";
export const Inhouse_ASK = "Ask Inhouse";
export const Inhouse_PRO = "Inhouse Pro";
export const Inhouse_COUNSEL = "Inhouse Counsel";

export const PLAN_TYPES = {
  MONTHLY: "monthly",
  YEARLY: "yearly",
};
